/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddTunnelToGroupContractCommand
 */
export interface AddTunnelToGroupContractCommand {
    /**
     * 
     * @type {string}
     * @memberof AddTunnelToGroupContractCommand
     */
    tunnelId: string;
}

/**
 * Check if a given object implements the AddTunnelToGroupContractCommand interface.
 */
export function instanceOfAddTunnelToGroupContractCommand(value: object): value is AddTunnelToGroupContractCommand {
    if (!('tunnelId' in value) || value['tunnelId'] === undefined) return false;
    return true;
}

export function AddTunnelToGroupContractCommandFromJSON(json: any): AddTunnelToGroupContractCommand {
    return AddTunnelToGroupContractCommandFromJSONTyped(json, false);
}

export function AddTunnelToGroupContractCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddTunnelToGroupContractCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'tunnelId': json['tunnelId'],
    };
}

export function AddTunnelToGroupContractCommandToJSON(json: any): AddTunnelToGroupContractCommand {
    return AddTunnelToGroupContractCommandToJSONTyped(json, false);
}

export function AddTunnelToGroupContractCommandToJSONTyped(value?: AddTunnelToGroupContractCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tunnelId': value['tunnelId'],
    };
}

